import { render, staticRenderFns } from "./ListArea.vue?vue&type=template&id=9045ab2e&"
import script from "./ListArea.vue?vue&type=script&lang=js&"
export * from "./ListArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports